export default __webpack_public_path__ + "static/media/carte-rfid.e43cd665.jpg";